import { omit } from 'lodash';

import { FormItem } from 'interfaces';

import { EXCEPT_FLOAT_NUMBERS_PATTERN, LOCALE_STRING_FORMAT } from '../constants/global';

export const removeLabelFromFormFields = (fields: FormItem[], shouldBeIgnored?: boolean): FormItem[] => {
  if (shouldBeIgnored) return fields;

  return fields.map((field) => {
    return omit(field, ['label']);
  });
};

export const formatAsThousands = (value?: number | null): string => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }

  return Math.round(value).toLocaleString(undefined, {
    maximumFractionDigits: 0,
  });
};

export const convertNumberInLocaleString = (value: string) => {
  return Number(value.replace(',', '')).toLocaleString(LOCALE_STRING_FORMAT, {
    maximumFractionDigits: 4,
  });
};

export const formatNumberInputValue = (value: string | number, fractionLength?: number, monetaryFigures?: boolean) => {
  const formattedByPatternValue = String(value).replace(EXCEPT_FLOAT_NUMBERS_PATTERN, '');

  if (!formattedByPatternValue || formattedByPatternValue === '.') {
    return monetaryFigures ? '0.00' : '0';
  }

  const numericValue = parseFloat(formattedByPatternValue);
  if (isNaN(numericValue)) {
    return monetaryFigures ? '0.00' : '0';
  }

  if (monetaryFigures) {
    return numericValue.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  const splitValueByDot = formattedByPatternValue.split('.');
  const mainPart = splitValueByDot[0];
  const fraction = splitValueByDot[1];

  if (formattedByPatternValue.charAt(formattedByPatternValue.length - 1) === '.' && fractionLength) {
    return convertNumberInLocaleString(mainPart) + '.';
  }

  return convertNumberInLocaleString(mainPart) + (fraction?.length ? `.${fraction.slice(0, fractionLength || 4)}` : '');
};

export const removeComaFromLocaleString = (value: string) => value?.replaceAll(',', '');
